import React from "react";
import { Layout } from "lucide-react";
import type { SlideRendererProps } from "../types";
import { SlideTemplates } from "./index";
import type { TemplateConfig } from "./index";

export const SlideRenderer: React.FC<SlideRendererProps> = ({
  slide,
  primaryColor,
  bgColor,
  slideStyle,
}) => {
  const config = SlideTemplates[slideStyle] as TemplateConfig;

  if (!config) return null;

  const contentArray = Array.isArray(slide.content)
    ? slide.content
    : (slide.content as string).split("\n").filter((line) => line.trim());

  return (
    <div
      className={`w-full h-full ${config.padding} flex flex-col justify-center relative overflow-hidden`}
      style={config.renderBackground(bgColor, primaryColor)}
    >
      {config.renderDecorations(primaryColor)}

      {slide.type === "title" ? (
        <div
          className={`text-center relative z-10 ${
            config.titleBorder ? "border-t-4 border-b-4 py-8" : ""
          }`}
          style={config.titleBorder ? { borderColor: primaryColor } : {}}
        >
          <h1
            className={`${config.titleSize} ${config.fontWeight} mb-6`}
            style={{
              color: primaryColor,
              letterSpacing: config.letterSpacing,
              textTransform: config.textTransform,
            }}
          >
            {slide.title}
          </h1>
          {contentArray.length > 0 && (
            <ul className={`${config.contentSize} ${config.spacing}`}>
              {contentArray.map((item: string, i: number) => (
                <li
                  key={i}
                  className="flex items-center justify-center gap-3"
                  style={{ color: "#202124" }}
                >
                  <span style={{ color: primaryColor }}>
                    {config.bulletIcon}
                  </span>
                  {item}
                </li>
              ))}
            </ul>
          )}
        </div>
      ) : (
        <div className="relative z-10">
          <div
            className={
              config.showIcon ? "flex items-center gap-4 mb-6" : "mb-6"
            }
          >
            {config.showIcon && (
              <div
                className="w-12 h-12 flex items-center justify-center"
                style={{ backgroundColor: primaryColor }}
              >
                <Layout className="w-6 h-6 text-white" />
              </div>
            )}
            <h2
              className={`${config.titleSize} ${config.fontWeight}`}
              style={{
                color: primaryColor,
                letterSpacing: config.letterSpacing,
                textTransform: config.textTransform,
              }}
            >
              {slide.title}
            </h2>
          </div>
          {contentArray.length > 0 && (
            <ul className={config.spacing}>
              {contentArray.map((item: string, i: number) => (
                <li
                  key={i}
                  className={`flex items-start gap-4 ${config.contentSize} ${
                    slideStyle === "minimal"
                      ? "pl-0"
                      : slideStyle === "corporate"
                        ? "pl-8"
                        : "pl-2"
                  }`}
                >
                  <span
                    className="mt-1 shrink-0"
                    style={{ color: primaryColor }}
                  >
                    {config.bulletIcon}
                  </span>
                  <span
                    className={
                      slideStyle === "minimal"
                        ? "font-light"
                        : slideStyle === "corporate"
                          ? "font-medium"
                          : ""
                    }
                    style={{ color: "#202124" }}
                  >
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
};
